<script>
import { pagamentoStatusLabels, pagamentoStatusValues } from '@tradimus/api-conciliacao-client'
import { pagamentoStatusTradimus } from '../../../libs/pagamento-status-tradimus'
import { sessionStorageClient } from '../../../libs'

export default {
  props: {
    operadoraAnsId: String,
    prestadorId: String,
    status: String,
    responsavel: String,
    minDataPagamento: String,
    maxDataPagamento: String,
    sla: String,
    prestadores: Array,
    operadoras: Array,
    tabKey: String
  },
  data () {
    return {
      statusList: pagamentoStatusValues
        .map(value => ({ value, text: pagamentoStatusLabels[value] })),
      slaOptions: ["3", "5", "6"]
    }
  },
  computed: {
    query () {
      return {
        operadoraAnsId: this.operadoraAnsId || undefined,
        prestadorId: this.prestadorId || undefined,
        status: this.status || undefined,
        minDataPagamento: this.minDataPagamento || undefined,
        maxDataPagamento: this.maxDataPagamento || undefined,
        sla: this.sla || undefined,
        responsavel: this.responsavel || undefined,
        tabKey: this.tabKey || undefined
      }
    },
    minFormattedDate () {
      return this.formatDate(this.minDataPagamento || '')
    },
    maxFormattedDate () {
      return this.formatDate(this.maxDataPagamento || '')
    },
    isUsuarioTradimus () {
      const isUsuarioTradimus = JSON.parse(sessionStorage.getItem('userData'))
      return isUsuarioTradimus.UsuarioTradimus
    },
    filterStatus () {
      if (this.isUsuarioTradimus) {
        return this.statusList
      } else {
        return this.statusList.filter(status => !(status.value in pagamentoStatusTradimus || status.value === 'faturamentoNaoIdentificado'))
      }
    }
  },
  methods: {
    updatePrestadorId (prestador) {
      sessionStorageClient.partialUpdate('pagamentosFilters', { prestadorId: prestador === null ? undefined : prestador.id })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          prestadorId: prestador === null ? undefined : prestador.id
        }
      })
    },
    updateOperadoraAnsId (operadoraAns) {
      sessionStorageClient.partialUpdate('pagamentosFilters', { operadoraAnsId: operadoraAns === null ? undefined : operadoraAns.id })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          operadoraAnsId: operadoraAns === null ? undefined : operadoraAns.id
        }
      })
    },
    updateStatus (status) {
      sessionStorageClient.partialUpdate('pagamentosFilters', { status: status === null ? undefined : status })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          status: status === null ? undefined : status
        }
      })
    },
    updateResponsavel (checked) {
      sessionStorageClient.partialUpdate('pagamentosFilters', { responsavel: checked ? 'true' : undefined })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          responsavel: checked ? 'true' : undefined
        }
      })
    },
    updateMinDataPagamento (minFormattedDate) {
      var minDataPagamento = undefined

      if (minFormattedDate) {
        const [day, month, year] = minFormattedDate.split('/')
        minDataPagamento = `${year}-${month}-${day}`
      }

      sessionStorageClient.partialUpdate('pagamentosFilters',{ minDataPagamento })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          minDataPagamento
        }
      })
    },
    updateMaxDataPagamento (maxFormattedDate) {
      var maxDataPagamento = undefined

      if (maxFormattedDate) {
        const [day, month, year] = maxFormattedDate.split('/')
        maxDataPagamento = `${year}-${month}-${day}`
      }

      sessionStorageClient.partialUpdate('pagamentosFilters', { maxDataPagamento })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          maxDataPagamento
        }
      })
    },
    updateSla (sla) {
      sessionStorageClient.partialUpdate('pagamentosFilters', { sla: sla ? sla : undefined })

      this.$router.push({
        name: 'pagamentos',
        query: {
          ...this.query,
          sla: sla ? sla : undefined
        }
      })
    },
    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },
    clearFilters () {
      sessionStorageClient.removeItem('pagamentosFilters')

      this.$router.push({
        name: 'pagamentos',
        query: {}
      })
    },
    applyFilters () {
      this.$emit('applyFilters')
    }
  }
}
</script>

<template>
  <v-container class="py-0 px-1">
    <v-form ref="pagamentosFilterForm">
      <v-row>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Prestador</label>
          <v-autocomplete
            :value="prestadorId"
            :items="prestadores"
            :item-text="item => `${item.nome} (${item.id})`"
            @input="updatePrestadorId"
            item-value="id"
            label="Selecione"
            hide-no-data
            outlined
            flat
            solo
            dense
            filled
            return-object
            clearable
            @click:clear="() => updatePrestadorId(null)"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>Operadoras</label>
          <v-autocomplete
            :value="operadoraAnsId"
            :items="operadoras"
            :item-text="item => `${item.nome} (${item.id})`"
            @input="updateOperadoraAnsId"
            item-value="id"
            label="Selecione"
            hide-no-data
            outlined
            flat
            solo
            dense
            filled
            return-object
            clearable
            @click:clear="() => updateOperadoraAnsId(null)"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="px-3 py-0">
          <label>SLA</label>
          <v-select
            :items="slaOptions"
            :value="sla"
            @change="updateSla"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            label="Selecione"
            solo
            dense
            outlined
            clearable
          />
        </v-col>
        <v-col class="py-0 px-3" cols="3">
          <label>Status</label>
            <v-select
              :items="filterStatus"
              :value="status"
              @change="updateStatus"
              :menu-props="{ bottom: true, offsetY: true }"
              flat
              label="Selecione"
              solo
              dense
              outlined
              clearable
            />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0 px-3" cols="3">
          <label>Data inicial</label>
          <v-text-field
            v-model="minFormattedDate"
            v-mask="'##/##/####'"
            placeholder="DD/MM/AAAA"
            dense
            label
            outlined
            append-icon="mdi-calendar-blank"
            clearable
            @click:clear="() => updateMinDataPagamento(undefined)"
            @change="updateMinDataPagamento"
          />
        </v-col>
        <v-col class="py-0 px-3" cols="3">
          <label>Data final</label>
          <v-text-field
            v-model="maxFormattedDate"
            v-mask="'##/##/####'"
            placeholder="DD/MM/AAAA"
            dense
            label
            outlined
            append-icon="mdi-calendar-blank"
            clearable
            @click:clear="() => updateMaxDataPagamento(undefined)"
            @change="updateMaxDataPagamento"
          />
        </v-col>
        <v-col class="py-0 px-3 d-flex" cols="3">
          <div class="shrink">
            <label>Responsável</label>
            <v-checkbox
              v-model="responsavel"
              @change="updateResponsavel"
              class="mt-0 ml-5"
              hide-details
            />
          </div>
        </v-col>
        <v-col class="filter-buttons" cols="3">
          <div class="d-flex justify-end">
            <v-btn
              color="primary"
              class="mr-3"
              depressed
              @click="applyFilters()"
            >
              Filtrar
            </v-btn>
            <v-btn
              outlined
              color="primary"
              depressed
              @click="clearFilters"
            >
              Limpar Filtros
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
